module.exports = __webpack_public_path__ + "assets/img/2b95df70ef76a8461574aa18f0fe0170.jpg";